import React from 'react';
import * as styles from './PostSkeleton.module.scss';

const PostSkeleton = () => (
  <div className={styles.container}>
    <div className={styles.title} />
    <div className={styles.line} />
    <div className={styles.line} />
    <div className={styles.line} />
  </div>
);

export default PostSkeleton;
